import React, { useState } from 'react';
import PaletteShowcase from './components/PaletteShowcase';
import UsageGuide from './components/UsageGuide';

const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'demo' | 'usage'>('demo');

  return (
    <div className="min-h-screen bg-background-dark">
      <div 
        className="fixed top-0 left-0 right-0 glass-effect border-b border-border-default"
        style={{ zIndex: 20000 }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold glow-text text-accent-cyan">
              Colors
            </h1>
            <nav className="flex gap-4">
              {(['demo', 'usage'] as const).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer ${
                    activeTab === tab
                      ? 'bg-accent-cyan/20 text-accent-cyan border border-accent-cyan/50 glow-border'
                      : 'text-text-secondary hover:text-text-primary hover:bg-surface-glass'
                  }`}
                >
                  {tab === 'demo' && '方案演示'}
                  {tab === 'usage' && '使用指南'}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>

      <div className="pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-6">
          {activeTab === 'demo' && <PaletteShowcase />}
          {activeTab === 'usage' && <UsageGuide />}
        </div>
      </div>
    </div>
  );
};

export default App;
